
import { mapState } from 'vuex';
import RetirementCalculatorInput from '@/ui/retirement-calculator/retirement-calculator-input.vue';

export default {
  name: 'PersonalForm',

  components: {
    RetirementCalculatorInput,
  },

  props: {
    isOnMobile: {
      default: true,
      type: Boolean,
    },
  },

  computed: {
    ...mapState({
      age: (state) => state['pension-calculator'].inputs.age,
      income: (state) => state['pension-calculator'].inputs.annual_gross_income,
      savings: (state) => state['pension-calculator'].inputs.monthly_savings,
      cash: (state) => state['pension-calculator'].inputs.total_savings_in_bank,
      sex: (state) => state['pension-calculator'].inputs.sex,
      education: (state) => state['pension-calculator'].inputs.education,
    }),

    sexOptions() {
      return Object.entries(this.$t('sex.options')).map(this.createOption);
    },
    educationOptions() {
      return Object.entries(this.$t('education.options')).map(
        this.createOption,
      );
    },
  },

  mounted() {
    // TODO: find a better place for this
    this.$store.commit('pension-calculator/initialValuesSet');
  },

  methods: {
    createOption([value, text]) {
      // The translation key needs to match the value expected by the BE
      return { value, text };
    },
  },
};
